import Accordion from './Accordion';

export default {
  install(Vue) {
    Vue.use(Accordion);
  },
};
